<template>
  <div class="additional-info">
    <h4>Documents</h4>
    <div class="grid">
      <b class="col-6">Invoice</b>
      <div class="col-6">
        <a-button
          @click="openAttachmentOnNewPage(paymentInfo.invoice.link)"
          size="small"
          icon="download"
          :disabled="!canDownloadInvoice"
        >
          Download
        </a-button>
      </div>

      <b class="col-6">Payment Agreement</b>
      <div class="col-6">
        <a-dropdown size="small">
          <a-button @click="downloadAssociateAgreement" :loading="loadingAgreement" size="small" icon="download">
            Download
          </a-button>
        </a-dropdown>
      </div>

      <b class="col-6">Time/Attendance Detail Report</b>
      <div class="col-6">
        <a-dropdown :disabled="contentDisabled" size="small">
          <a-menu slot="overlay">
            <a-menu-item key="pdf" class="flex align-items-center gap-2" @click="downloadTimeAttendanceReport('PDF')">
              <a-icon icon="teenyicons:pdf-outline" width="16px" height="16px" />
              PDF
            </a-menu-item>
            <a-menu-item
              key="excel"
              class="flex align-items-center gap-2"
              @click="downloadTimeAttendanceReport('EXCEL')"
            >
              <a-icon icon="teenyicons:ms-excel-outline" width="16px" height="16px" />
              Excel
            </a-menu-item>
          </a-menu>
          <a-button size="small" icon="download"> Download </a-button>
        </a-dropdown>
      </div>

      <b class="col-6">Shift Time Cards</b>
      <div class="col-6">
        <a-button @click="downloadShiftTimeCardsReport" size="small" icon="download" :loading="loadingTimeCards">
          Download
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import util from '@/util'
import { Button, Dropdown, Menu, notification } from 'ant-design-vue'
import moment from 'moment-timezone'
import { createNamespacedHelpers } from 'vuex'

const { mapActions: paymentActions } = createNamespacedHelpers('payment')
const { mapActions: reportActions } = createNamespacedHelpers('report')

export default {
  components: {
    'a-dropdown': Dropdown,
    'a-button': Button,
    'a-menu': Menu,
    'a-menu-item': Menu.Item
  },
  props: {
    paymentInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      timeAttendanceExportFormatType: {
        PDF: 0,
        EXCEL: 1
      },

      loadingAgreement: false,
      loadingTimeCards: false
    }
  },
  computed: {
    canDownloadInvoice() {
      return this.paymentInfo.invoice ? this.paymentInfo.invoice.link : false
    },

    contentDisabled() {
      return !this.paymentInfo.shift_payments || this.paymentInfo.shift_payments.length === 0
    }
  },
  methods: {
    ...reportActions(['getTimeAttendanceDetailReport', 'downloadShiftCards']),
    ...paymentActions(['downloadAgreement']),

    showNotification(type, message, description) {
      notification[type]({
        message,
        description
      })
    },

    openAttachmentOnNewPage(file) {
      window.open(file, '_blank')
    },

    async downloadAssociateAgreement() {
      if (!this.paymentInfo.payment.id) {
        return
      }

      this.loadingAgreement = true

      const payload = {
        payment_id: this.paymentInfo.payment.id
      }

      try {
        const url = await this.downloadAgreement(payload)

        util.downloadFile(url)
      } catch (error) {
        this.showNotification('error', 'Error', error.message || error)
      } finally {
        this.loadingAgreement = false
      }
    },

    async downloadTimeAttendanceReport(type) {
      this.loading = true
      try {
        const url = await this.getTimeAttendanceDetailReport({
          filters: {
            ids: this.paymentInfo.shift_payments
              .filter(shift => !['deleted', 'denied', 'cancelled'].includes(shift.shift_payment.status))
              .map(shift => shift.shift.id),
            date_from: moment().utc(true).format('YYYY-MM-DD'),
            date_to: moment().utc(true).format('YYYY-MM-DD'),
            group_by: 0
          },
          type
        })

        util.downloadFile(url)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error.message)
      } finally {
        this.loading = false
      }
    },

    async downloadShiftTimeCardsReport() {
      this.loadingTimeCards = true
      try {
        const url = await this.downloadShiftCards({
          filters: {
            shift_ids: this.paymentInfo.shift_payments.map(shift => shift.shift.id),
            start: null,
            end: null,
            cdph_report_format: 'all',
            report_format: 'all'
          }
        })

        util.downloadFile(url)
      } catch (error) {
        this.showNotification('error', 'Error', typeof error === 'string' ? error : error.message)
      } finally {
        this.loadingTimeCards = false
      }
    }
  }
}
</script>

<style scoped>
.additional-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: absolute;
  right: -310px;
  background-color: var(--bg-component);
  width: 300px;
  height: fit-content;
  top: 0px;
  border-radius: 12px;
  padding: 16px 20px;
}
</style>
